export default "__VITE_ASSET__bb33fdfd__"